<oaibox-stats-card title="Logs" icon="fa-solid fa-file-lines" gradient="secondary">
  <div class="logs-modal">
    @if (hasLogs) {
      <h2 class="logs-date-title">{{ selectedDateLabel }}</h2>
    }

    <ul class="logs-list">
      @for (entry of filteredLogs; track $index) {
        <li class="log-card">
          <div class="log-card-header">
            <span class="log-username">{{ entry.username }}</span>
            <span class="log-timestamp">{{ entry.timestamp | date: "dd/MM/yyyy HH:mm" }}</span>
          </div>
          <p class="log-message">{{ entry.message }}</p>
        </li>
      } @empty {
        <li class="empty-list">
          <strong class="text-muted fs-5">No Logs</strong>
        </li>
      }
    </ul>

    @if (hasLogs) {
      <div class="logs-timeline" [id]="timelineChartId"></div>
    }
  </div>
</oaibox-stats-card>
